import * as yup from 'yup';
import {IWorkWithUsErrorMessages} from '@/dictionaries/pages/aboutUs/types';

export function getTranslatedSchema(dict: IWorkWithUsErrorMessages) {
  return yup.object().shape({
    name: yup.string().required(dict.name),
    surname: yup.string().required(dict.surname),
    email: yup.string().email(dict.email).required(dict.email),
    file: yup.mixed().required(dict.file),
    terms: yup.boolean().oneOf([true], dict.terms).required(dict.terms),
  });
}

export function getBaseTranslatedSchema(dict: IWorkWithUsErrorMessages) {
  return getTranslatedSchema(dict).pick([
    'name',
    'surname',
    'email',
    'file',
    'terms',
  ]);
}
